var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowGoHome)?_c('div',{staticClass:"toHome",on:{"click":_vm.toHome}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }